<script setup>
    const appName = process.env.APP_NAME;
    const assetUrl = process.env.ASSET_URL;

</script>

<template>
    <a class="relative" href="/">
        <img class="logo-mobile"
          :src="assetUrl + 'EVEDLogoSmall.png'"
          :alt="appName">
    </a>
</template>

<style scoped lang="scss">
.flex-60 {
    flex: 0 0 15rem;
}
</style>
